$(function() {
	var $body = $('body');

	var openDownload = function(url) {
		if (url.match(/mirror=local/)) {
			window.location.href = url;
		} else {
			window.open(url, '_blank');
		}
	};


	var showPopup = function(options) {
		var $popup = $('<div/>', {class: 'popup popup-info'}),
			$popupBody = $('<div/>'),
			$popupBg = $('<div/>', {class: 'popup-overlay'});

		if (options.content) {
			var content = options.content;
			if (!content instanceof Array) {
				content = [content];
			}
			var i;
			for (i in content) {
				$popupBody.append(content[i]);
			}
		}

		if (options.popupClass) {
			$popup.addClass(options.popupClass);
		}

		$popupBg.on('click', closePopup);


		$popup.append($popupBody);
		$body.append($popupBg).append($popup);

		return $body;
	};


	var closePopup = function() {
		var $elements = $('.popup, .popup-overlay');
		$elements.fadeOut(200, function() {
			$elements.remove();
		});
	};


	var downloadStarted;
	$('.download a').on('click', function(e) {
		var $a = $(this);
		if ($a.parents('.downloads').hasClass('downloads-data')) return;

		if ($a.hasClass('mirror-drive')) {
			// drive always opens right away
			return true;
		}

		e.preventDefault();

		if (window.loggedIn) {
			openDownload($a.attr('href'));
		} else {
			downloadStarted = false;

			showPopup({
				content: [
					'<p>Thank you! The download is starting right now.</p>',
					'<h3>Sign up for the newsletter for news and special offers:</h3>',
					$('#frm-newsletterForm').removeClass('inline').addClass('vertical'),
					'<hr/>',
					'<p><a class="popup-close">Close this window</a>'
				]
			});

			window.setTimeout(function() {
				openDownload($a.attr('href'));
				downloadStarted = true;
			}, 500);
		}
	});

	$body.on('click', '.popup-open', function(e) {
		var $this = $(this);
		var content = [];
		var popupClass = $this.data('popup-class') || '';
		if ($this.hasClass('popup-show-title')) {
			content.push('<p>' + $this.attr('title') + '</p>');
			content.push('<p><a class="popup-close">close</a>');
			showPopup({content: content, popupClass: popupClass});
		} else if ($this.hasClass('popup-ajax')) {
			e.preventDefault();
			$.get($this.attr('href'), {layout: "content"}, function(data) {
				content.push(data);
				if ($this.hasClass('popup-accept')) {
					var $a = $('<a class="popup-close btn">I Accept</a>').on('click', function() {
						$this.closest('label').find('input[type=checkbox]').prop('checked', true);
					});
					content.push($('<p style="text-align:center"></p>').append($a))
				} else {
					content.push('<p style="text-align:center"><a class="popup-close btn">close</a></p>');
				}
				showPopup({content: content, popupClass: popupClass});
			});
		}

	});

	$body.on('click', '.popup-close', function() {
		closePopup();
	});
	$('.all').on('click', function() {
		if (downloadStarted) {
			closePopup();
		}
	});


	$.nette.ext('popup', {
		success: function(payload) {
			if (payload.messageContext == 'basket') {
				if (payload.skipFlash) return;

				var $popup = $('<div/>', {class: 'popup popup-' +  payload.messageType}),
					$message = $('<p/>').html(payload.message),
					$buttons = $('<p/>', {class: 'buttons'}),
					$button1, $button2;
				if (payload.messageType == 'error') {
					$button1 = $('<a/>', {class: 'btn btn-primary'}).text('Got it');
					$buttons.append($button1);
				} else {
					$button1 = $('<a/>', {class: 'btn btn-primary'}).text('Continue shopping');
					$button2 = $('<a/>', {class: 'btn btn-secondary', href: '/basket'}).text('Open shopping cart');
					$buttons.append($button1).append($button2);
				}

				$button1.on('click', function() {
					$popup.fadeOut(100, function() {
						$(this).remove();
					});
				});
				$popup.append($message).append($buttons);
				$popup.appendTo('body');

			} else if (payload.messageType) {
				if (payload.skipFlash) return;

				var $popup = $('<div/>', {class: 'popup popup-' +  payload.messageType}),
					$message = $('<p/>').html(payload.message),
					$button = $('<a/>', {class: 'btn bt-primary'}).text('Got it')
					;

				$button.on('click', function() {
					$popup.fadeOut(100, function() {
						$(this).remove();
					});
				});
				$popup.append($message).append($button);
				$popup.appendTo('body');
			}

			if (payload.dataLayer) {
				if (typeof dataLayer === "undefined") {
					console.log("debug data layer push", payload.dataLayer);
				} else {
					dataLayer.push(payload.dataLayer);
				}
			}
		}
	}, {});

});
